import type { FluxErrorEntityErrorCodes } from '../types.js';

export const LabelErrorCodes = {
  LabelBatchNotFound: {
    code: 'label/batch-not-found',
    explanation: 'Uma ou mais etiquetas que você está tentando acessar não foram encontradas.',
    localizations: {},
    message: 'Uma ou mais etiquetas não foram encontradas.',
  },
  LabelNotFound: {
    code: 'label/not-found',
    explanation: 'A etiqueta que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Etiqueta não encontrada.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'label'>;
